@if (sidebarElement(); as link) {
  <mat-tab-group animationDuration="0ms">
    <mat-tab label="{{ 'Details' | transloco }}">
      <div class="sidebar-content--detail-tab">
        @if (isSourceOfLinkDecision() && showLinkValue()) {
          <sidebar-link-value
            [decisionODType]="decisionODType()"
            [decisionRuleType]="decisionRuleType()"
            [link]="link"
            [loading]="awaitRuleType()"
            [sourceDecision]="sourceDecision()"
            (linkValueChanged)="flowchartElementDataChanged.emit($event)" />
        }

        @if (!isSourceOfLinkDecision()) {
          <div class="flowchart-sidebar-link_label">
            <label class="flowchart-sidebar-link_label-label" for="flowchart-sidebar-link_label-input" ttLabel>
              {{ 'Flowchart.Links.Label' | transloco }}:
            </label>
            <input
              id="flowchart-sidebar-link_label-input"
              placeholder="{{ 'Flowchart.Links.LabelPlaceholder' | transloco }}"
              step=".01"
              ttInput
              type="text"
              [ngModel]="label()"
              (ngModelChange)="onLabelChange($event)" />
          </div>
        }

        <sidebar-recurrence
          [isSidebarLink]="true"
          [recurrence]="link.linkOffset?.position"
          [recurrenceInterval]="link.linkOffset?.offset"
          (recurrenceChanged)="onLinkOffsetPosition($event)"
          (recurrenceIntervalChanged)="onLinkOffsetOffsetChanged($event)" />
      </div>
    </mat-tab>
  </mat-tab-group>
}
